import { render } from "./admin-price.vue?vue&type=template&id=350e0106&scoped=true"
import script from "./admin-price.vue?vue&type=script&lang=js"
export * from "./admin-price.vue?vue&type=script&lang=js"

import "./admin-price.vue?vue&type=style&index=0&id=350e0106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e0106"]])

export default __exports__